import { useToast } from "@memorang/ui/components/Toast";
import * as Clipboard from "expo-clipboard";

export const useCopyToClipboard = () => {
	const { showToast } = useToast();

	const copyToClipboard = async (
		text: string,
		toastMessage = "Copied to clipboard",
	) => {
		await Clipboard.setStringAsync(text);
		showToast({
			message: toastMessage,
			duration: 1000,
		});
	};

	return { copyToClipboard };
};
